<template>
  <!-- 删除监控-选择商品 -->
  <div v-show="isShow">
    <!-- 头部查询表单 -->
    <div class="headSearchForm">
      <inputForm v-if="skuSearch" :inputData="inputData1" ref="inputForm" @toParentVal="handleSearch"
        :btnPosition2="true"></inputForm>
      <inputForm v-else :inputData="inputData" ref="inputForm" @toParentVal="handleSearch" :btnPosition2="true">
      </inputForm>
    </div>
    <!-- 选择商品区块 -->
    <div class="goodsContent">
      <!-- 左边盒子 -->
      <div class="left">
        <div class="titleBox">
          <div class="tit">店内商品({{total}})</div>
          <div>
            <jd-button label="更新" @click="updateGoods" type="text" />
            <jd-button label="按查询结果选择" style="margin-left: 8px;" @click="allShop()" type="text" />
            <jd-button label="全选" style="margin-left: 8px;" @click="selectAll()" type="text" />
          </div>
        </div>

        <!-- 商品滚动盒子 -->
        <div class="goodsScrollBox" v-loading="tableLoading">
          <!-- <div v-loading="tableLoading"> -->
            <template v-if="goodsList.length == 0">
              <div class="noDataBox">
                <jd-image :src="$globalCdn + '/images/leftOrNoCxt.png'" alt />
                <span>暂无任何数据</span>
              </div>
            </template>
            <div class="goods" :class="{ isAdd: item.isAdd }" v-for="item in goodsList"
              :key="skuSearch ? item.skuId : item.wareId">
              <!-- <a :href="item.itemUrl" target="_blank"> -->
                <img :src="item.logo" class="avar" alt="商品图片" />
                <div class="desc">
                  <a :href="item.itemUrl" target="_blank" style="padding-top: 10px;">
                  <p :title="item.wareTitle" class="goodsName">
                    {{ item.wareTitle }}
                  </p>
                  </a>
                  <div class="foot">
                    <div>
                      <span class="money">￥{{ item.jdPrice }}</span>
                      <span v-if="skuSearch" class="goodsId">sku ID:{{ item.skuId }}</span>
                      <span v-else class="goodsId">商品ID:{{ item.wareId }}</span>
                    </div>
                  </div>
                </div>
              <!-- </a> -->
              <div>
                <img v-if="findgoods(item.skuId)" src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/add_icon.svg" class="addIcon" alt="添加icon" @click="addGoods(item)" />
                <img v-else src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/add_icon.svg" class="addIcon" alt="添加icon" style="opacity: 0.6;" />
              </div>
            </div>
          <!-- </div> -->
        </div>
        <!-- 分页 -->
        <div class="new-pagination-page">
          <el-pagination @size-change="handleLeftSizeChange" @current-change="handleLeftCurrentChange"
            :current-page="currentLeftPage" background small :page-sizes="[5, 10, 50, 100, 500, 1000]"
            :page-size="pageSizeLeft" :pager-count="5" layout="sizes, prev, pager, next, jumper"
            class="pagination" :total="total">
          </el-pagination>
        </div>
      </div>
      <!-- 右边盒子 -->
      <div class="right">
        <div class="titleBox" style="justify-content: start;">
          <span class="tit" style="flex: 1;">已选商品（{{ selectedGoodsList.length }}）</span>
          <!-- <span class="clear" style="right: 102px;" @click="selectGoodsList()">选择分组</span>
          <span class="clear" style="right: 42px;" @click="saveGoodsList()">保存分组</span>
          <span class="clear" @click="empty()">清空</span> -->
          <jd-button type="blueText" @click="selectGoodsList()">选择分组</jd-button>
          <jd-button type="blueText" @click="saveGoodsList()">保存分组</jd-button>
          <jd-button type="blueText" @click="empty()">清空</jd-button>
        </div>
        <!-- 商品滚动盒子 -->

        <div class="goodsScrollBox" v-loading="tableRightLoading">
          <template v-if="selectedGoodsList.length == 0">
            <div class="noDataBox" style="text-align: center;">
              <jd-image :src="$globalCdn + '/images/leftOrNoCxt.png'" alt />
              <span>暂无任何数据</span>
            </div>
          </template>
          <template>
            <div class="goods" v-for="(item, index) in showSelectedGoodsList"
              :key="skuSearch ? item.skuId : item.wareId + index">
              <img :src="item.logo" class="avar" alt="商品图片" />
              <div class="desc">
                <p :title="item.wareTitle" class="goodsName">
                  {{ item.wareTitle || item.title || item.skuName}}
                </p>
                <div class="foot">
                  <div>
                    <span class="money">￥{{ item.jdPrice || item.price }}</span>
                    <span v-if="skuSearch" class="goodsId">sku ID:{{ item.skuId }}</span>
                    <span v-else class="goodsId">商品ID:{{ item.wareId }}</span>
                  </div>
                  <div><img src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/clear_icon.svg" class="addIcon" alt="添加icon"
                      @click="clearGoods(item, index)" /></div>
                </div>
              </div>
            </div>
          </template>
        </div>
        <!-- 分页 -->
        <div class="new-pagination-page">
          <el-pagination @size-change="handleRigthSizeChange" @current-change="handleRightCurrentChange"
            :current-page="currentRightPage" small :pager-count="5" background :page-sizes="[5, 10, 50, 100, 500, 1000]"
            :page-size="pageSizeRight" layout="sizes, prev, pager, next, jumper" class="pagination"
            :total="selectedGoodsList.length">
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- 底部按钮 -->
    <!-- <div class="footer">
      <button class="cancel" @click="cancel">取消</button>
      <button class="confirm" @click="sure">确定</button>
    </div> -->
    <!-- 选择分组弹窗 -->
    <el-dialog style="z-index: 4000;" width="800px" title="选择分组" :visible.sync="selectVisible">
      <div style="height: 400px;overflow: auto;">
        <el-table v-loading="tableLoding" tooltip-effect="light" :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }" :row-style="{'height':'48px'}" :cell-style="{ 'text-align': 'left','height':'48px !important' }" :data="selectTable" border style="width: 100%">
          <el-table-column prop="groupName" label="分组名称">
          </el-table-column>
          <el-table-column prop="skuNum" label="所选sku数" width="180">
          </el-table-column>
          <el-table-column label="操作" width="120">
            <template slot-scope="scope">
              <div style="width: 100%;height:100%;display: flex;align-items: center;">
                <span @click="addGroup(scope.row.groupId)" style="color:#2768FF;cursor: pointer;" >添加</span>
                <span @click="delGroup(scope.row.groupId)" style="color:#2768FF;margin-left: 12px;cursor: pointer;" >删除</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <!-- 保存分组 -->
    <el-dialog style="z-index: 4000;" width="500px" title="保存分组" :visible.sync="saveVisible">
      <div>
        <el-radio v-model="saveRadio" label="新建分组">新建分组</el-radio>
        <el-radio v-model="saveRadio" label="已有分组">已有分组</el-radio>
        <div style="display: flex;flex-wrap: nowrap;margin-top: 8px;" v-if="saveRadio=='新建分组'">
          <div style="width: 100px;display: flex;align-items: center;"><span style="color: red;">*</span>分组名称：</div>
          <el-input placeholder="请输入分组名称" v-model="groupName" maxlength="20" show-word-limit />
        </div>
        <div style="display: flex;flex-wrap: nowrap;margin-top: 8px;" v-if="saveRadio=='已有分组'">
          <div style="width: 100px;display: flex;align-items: center;"><span style="color: red;">*</span>选择分组：</div>
          <el-select v-model="selsectGroup" placeholder="请选择">
            <el-option v-for="item in groupOptions" :key="item.groupId" :label="item.groupName" :value="item.groupId">
            </el-option>
          </el-select>
          <!-- <el-input placeholder="请输入分组名称" v-model="groupName" maxlength="20" show-word-limit /> -->
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <jd-button label="取消" @click="saveVisible = false" />
        <jd-button label="确定" style="margin-left: 8px;" @click="saveSpuList()" type="break" />
      </span>
    </el-dialog>

    <!-- </el-dialog> -->
  </div>
</template>

<script>
import { getSellercats, getTaobaoItemList, getTaobaoItemListSku, addToGroup, getGroupList, delSkuGroup, getSkuListByGroup } from "@/api/analysis/ware-controller";
import { synchroJdWare } from "@/api/serviceCenter/popCommentWareAnalysis";
import myPopup from "./myPopup";
import inputForm from "./inputForm";

export default {
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    selectGoods: {
      type: Array,
      default: () => {
        return [];
      },
    }, // 用于回显选中的商品
    moduleType: {
      type: Boolean,
      default: false,
    },
    skuSearch: {
      type: Boolean,
      default: false,
    },
    xianz: {
      type: Boolean,
      default: false,
    },
    // 数量限制
    limit:{
      type:Number,
      default: 0,
    },
    venderId: {
      type: [Number,String],
      default: 0,
    }
  },
  watch: {
    isShow(newVal) {
      if (newVal && this.moduleType) {
        this.selectedGoodsList = JSON.parse(JSON.stringify(this.selectGoods));
        this.showSelectedGoodsList = JSON.parse(JSON.stringify(this.selectGoods));
        if (this.skuSearch) {
          this.ids = this.selectGoods.map((i) => Number(i.skuId));
          console.log(this.ids, this.selectGoods, 22222);
        } else {
          console.log(this.ids, this.selectGoods);
          this.ids = this.selectGoods.map((i) => Number(i.wareId));
        }
        this.$nextTick(() => {
          // this.$refs.inputForm.formSearch();
          this.searchForm();
          this.GroupList()
        });
        // console.log(this.selectGoods, this.ids);
      }
    },
  },
  components: {
    myPopup,
    inputForm,
  },
  data() {
    return {
      // 1.11 分组弹窗参数
      saveRadio:'新建分组',
      groupName:'',
      groupOptions:[],
      selsectGroup:'',
      selectVisible:false,
      saveVisible:false,
      selectTable:[], //选择分组
      tableLoding:false,

      activeName: "2",
      inputData: [
        // 头部查询表单配置项
        {
          name: "商品类目",
          placeholder: "请选择",
          val: "categoryId",
          cascaderArr: [],
          // multiple: this.skuSearch,
          multiple: true,
        },
        {
          name: "SKU ID",
          val: "skuId",
          placeholder: "请输入SKU ID, 多个请用,隔开",
        },
        {
          name: "商品状态",
          val: "wareStatus",
          default: '',
          selectArr: [
            { label: "全部", id: ''},
            { label: "上架", id: 1 },
            { label: "下架", id: 2 },
          ],
        },
        {
          name: "商品编码",
          val: "wareIdStr",
          placeholder: "请输入商品编码，多个请用,隔开",
        },
        {
          name: "商品名称",
          val: "wareTitle",
          placeholder: "请输入商品名称",
        },
      ],
      inputData1: [
        // 头部查询表单配置项
        {
          name: "商品类目",
          placeholder: "请选择",
          val: "categoryId",
          cascaderArr: [],
          // multiple: this.skuSearch,
          multiple: true,
        },
        {
          name: "SKU ID",
          val: "skuId",
          placeholder: "请输入SKU ID, 多个请用,隔开",
        },
        {
          name: "商品状态:",
          val: "skuStatus",
          default: 1,
          selectArr: [
            { label: "全部", id: ''},
            { label: "上架", id: 1 },
            { label: "下架", id: 2 },
          ],
        },
        {
          name: "商品编码",
          val: "wareIdStr",
          placeholder: "请输入商品编码，多个请用,隔开",
        },
        {
          name: "商品名称",
          val: "skuName",
          placeholder: "请输入商品名称",
        },
      ],
      total: 0,
      goodsList: [], // 左边店内商品数据

      currentLeftPage: 1, // 左边店内商品当前页

      selectedGoodsList: [], // 右边已选商品数据
      showSelectedGoodsList: [], // 右边显示已选商品

      currentRightPage: 1, // 右边已经商品当前页

      tableLoading: false, //左盒子loading
      tableRightLoading:false, //右盒子loading 仅 按查询结果选择 使用
      ids: [], //已选商品id集合,防止同一个商品可被多次选中

      pageSizeLeft: 5,
      pageSizeRight: 5,
      fromObj: {
        skuStatus: 1,
        wareStatus: '',
      },
      formCopy:{

      },
      allShopList: [],
    };
  },
  created() {
    console.log(this.skuSearch);
    if (this.moduleType) {
      // console.log(this.selectGoods);
      this.selectedGoodsList = this.selectGoods;
      this.ids = this.selectGoods.map((i) => Number(i.wareId));
      // console.log(this.ids);
    }
  },
  mounted() {
    this.init(); //初始化
    // 根据分页size截取数组
    this.sliceArr(this.currentRightPage, this.pageSizeRight);
  },
  methods: {
    findgoods(val){
      let isCan = true
      this.showSelectedGoodsList.forEach(item=>{
        if(val == item.skuId){
          isCan = false
        }
      })
      return isCan
    },
    // 添加商品
    async addGroup(id) {
      const venderId = this.venderId ? this.venderId : this.$store.getters.loginUserInfo.venderId
      let res = await getSkuListByGroup(id,venderId)
      if(res.code==1){
        res.data.forEach(item=>{
          let ispush = true
          this.selectedGoodsList.forEach(it=>{
            if(it.skuId == item.skuId){
              ispush = false
            }
          })
          if(ispush){
            this.addGoods(item)
          }
        })
        this.searchForm()
        this.selectVisible = false
      }else{
        this.$message({
          type: 'error',
          message: res.message
        });
      }
    },
    // 删除商品组
    delGroup(id) {
      this.$confirm('是否确认删除此分组?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const venderId = this.venderId ? this.venderId : this.$store.getters.loginUserInfo.venderId
        delSkuGroup(id,venderId).then(res => {

          if (res.code == 1) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.GroupList()
          } else {
            this.$message({
              type: 'error',
              message: res.message
            });
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    // 获取商品列表
    async GroupList(){
      this.tableLoding = true
      let res = await getGroupList({
        venderId: this.venderId ? this.venderId : this.$store.getters.loginUserInfo.venderId,
      })
      if(res.code==1){
        this.groupOptions = res.data
        this.selectTable = res.data
        this.tableLoding = false
      }else{
        this.tableLoding = false
      }
    },

    // 保存sku分组  
    saveSpuList(){
      let formData={
        groupId:'',
        groupName:'',
        venderId: this.venderId ? this.venderId : this.$store.getters.loginUserInfo.venderId,
      }
      if(this.saveRadio=='新建分组'){
        if(this.groupName == ''){
          this.$message.warning('分组名称不可为空')
          return
        }
        formData.groupName = this.groupName
      }
      if(this.saveRadio=='已有分组'){
        if(this.selsectGroup == ''){
          this.$message.warning('请选择分组')
          return
        }
        formData.groupId = this.selsectGroup
        this.groupOptions.forEach( item => {
          if(item.groupId == formData.groupId){
            formData.groupName = item.groupName
          }
        })
      }
      formData.idList = this.selectedGoodsList.map(item=>{
        return item.skuId
      })
      addToGroup(formData).then(res=>{
        if(res.code==1){
          this.saveVisible = false
          this.$message.success('创建成功')
          this.GroupList()
        }else{
          this.$message.error(res.message)
        }
      })
    },
    // 选择分组
    selectGoodsList(){
      this.selectVisible = true
    },
    // 保存分组
    saveGoodsList(){
      this.saveVisible = true
      this.groupName = ''
      this.selsectGroup = ''
    },
    init() {
      // 获取商品类目
      getSellercats().then((res) => {
        let data = this.transverter(res.data);
        this.getTrees(data);
        let list = data.filter((item) => item.parent_id == 0);
        console.log("list", list);
        let cascaderArr = list.map((item) => {
          return {
            label: item.label,
            value: item.value,
            children: item.children,
          };
        });
        console.dir(cascaderArr);

        this.inputData[0].cascaderArr = cascaderArr;
        this.inputData1[0].cascaderArr = cascaderArr;
        // console.log(this.inputData[0]);
      });
      this.$nextTick(() => {
        // this.$refs.inputForm.formSearch();
        this.searchForm();
      });
    },
    sure() {
      console.log("选中商品", this.selectedGoodsList);
      this.$emit("close", this.selectedGoodsList);
    },
    cancel() {
      this.$emit("close", false);
    },
    transverter(data) {
      // 排重
      let obj = {};
      for (let i = 0; i < data.length; i++) {
        obj[data[i]["categoryId"]] = data[i];
      }
      let arr = Object.values(obj);
      var newData = [];
      // console.log(arr);
      for (var i = 0; i < arr.length; i++) {
        newData[i] = {
          value: arr[i].categoryId,
          parent_id: arr[i].parentId,
          label: arr[i].name,
          isChecked: false,
        };
      }
      return newData;
    },
    getTrees(list, parent_id = 0) {
      let parentObj = {};
      list.forEach((o) => {
        parentObj[o.id] = o;
      });
      if (!parent_id) {
        return list
          .filter((o) => !parentObj[o.parent_id])
          .map((o) => {
            if (this.getTrees(list, o.value).length == 0) {
              // console.log(this.getTrees(list, o.value).length);
              delete o.children;
              return o;
            } else {
              return (o.children = this.getTrees(list, o.value)), o;
            }
          });
      } else {
        return list
          .filter((o) => o.parent_id == parent_id)
          .map((o) => {
            if (this.getTrees(list, o.value).length == 0) {
              // console.log(this.getTrees(list, o.value).length);
              delete o.children;
              return o;
            } else {
              return (o.children = this.getTrees(list, o.value)), o;
            }
          });
      }
    },
    /**
     * 弹窗隐藏
     */
    popupClose() {
      this.$emit("close", false);
    },
    /**
     * 表单查询商品列表
     */
    searchForm(form = this.fromObj) {
      console.log(this.fromObj, 5555);
      this.tableLoading = true;
      form.current = this.currentLeftPage;
      if (form.categoryId) {
        form.categoryId = form.categoryId;
      }
      if (this.skuSearch) {
        getTaobaoItemListSku({
          ...form,
          size: this.pageSizeLeft,
          venderId: this.venderId ? this.venderId : this.$store.getters.loginUserInfo.venderId,
        }).then((res) => {
          this.tableLoading = false;
          if (res.code == 1) {
            res.data.records.map((item) => {
              item.wareTitle = item.skuName;
            });
            this.goodsList = res.data.records;
            if (this.moduleType) {
              this.goodsList.forEach((item) => {
                // 避免直接赋值导致左右两侧商品盒子数组地址不一致，状态没有同步响应
                // const state = this.ids.includes(item.skuId);
                // const state = this.ids.indexOf(item.skuId);
                this.ids.forEach((ele) => {
                  if (ele == item.skuId) {
                    item.isAdd = true;
                  }
                });
              });
            }
            // console.log(res.data.records);
            this.total = +res.data.total;
           
          } else {
            this.goodsList = [];
          }
        });
      } else {
        getTaobaoItemList({
          ...form,
          page: form.current,
          pageSize: this.pageSizeLeft,
          venderId: this.venderId ? this.venderId : this.$store.getters.loginUserInfo.venderId,
        }).then((res) => {
          this.tableLoading = false;
          if (res.data == null) {
            this.goodsList = [];
          }
          if (res.code == 1) {
            this.goodsList = res.data.records;
            if (this.moduleType) {
              // console.log(this.ids);
              this.goodsList.forEach((item) => {
                // 避免直接赋值导致左右两侧商品盒子数组地址不一致，状态没有同步响应
                const state = this.ids.includes(item.wareId);
                // console.log(state);
                if (state) {
                  item.isAdd = true;
                }
              });
            }
            // function myIsNaN(value) {
            //     return typeof value === 'number' && !isNaN(value);
            // }
            this.sliceArr(this.currentRightPage, this.pageSizeRight);
            // console.log(res.data.records);
            this.total = +res.data.total;
          } else {
            this.goodsList = [];
          }
        });
      }
    },
    handleSearch(form, isSearch = false) {
      this.fromObj = form;
      this.currentLeftPage = 1;
      // console.log(from, 5555);
      this.tableLoading = true;
      form.current = this.currentLeftPage;
      form.categoryId = typeof form.categoryId == "object" && form.categoryId.length ? form.categoryId.join(",") : form.categoryId;
      // if (isSearch) {
      //   form.current = 1;
      // }
      this.formCopy = JSON.parse(JSON.stringify(form))
      if (Array.isArray(form.categoryId) && form.categoryId.length === 0) {
        form.categoryId = '';
      }
      if (this.skuSearch) {
        getTaobaoItemListSku({
          ...form,
          size: this.pageSizeLeft,
          venderId: this.venderId ? this.venderId : this.$store.getters.loginUserInfo.venderId,
        }).then((res) => {
          this.tableLoading = false;
          if (res.code == 1) {
            // console.log(res.data.records);
            res.data.records.map((item) => {
              item.wareTitle = item.skuName;
            });
            this.goodsList = res.data.records;
            console.log(this.ids);
            if (this.moduleType) {
              this.goodsList.forEach((item) => {
                // 避免直接赋值导致左右两侧商品盒子数组地址不一致，状态没有同步响应
                const state = this.ids.includes(item.skuId);
                if (state) {
                  item.isAdd = true;
                }
              });
            }
            console.log(res.data.records);
            this.total = +res.data.total;
          } else {
            this.goodsList = [];
          }
        });
      } else {
        // console.log(this.pageSizeLeft);
        getTaobaoItemList({
          ...form,
          page: form.current,
          pageSize: this.pageSizeLeft,
          venderId: this.venderId ? this.venderId : this.$store.getters.loginUserInfo.venderId,
        }).then((res) => {
          console.log(res.data);
          this.tableLoading = false;
          if (res.data == null) {
            this.goodsList = [];
          }
          if (res.code == 1) {
            this.goodsList = res.data.records;
            if (this.moduleType) {
              this.goodsList.forEach((item) => {
                // console.log(item.wareId);
                // 避免直接赋值导致左右两侧商品盒子数组地址不一致，状态没有同步响应
                const state = this.ids.includes(item.wareId);
                // console.log(state);
                if (state) {
                  item.isAdd = true;
                }
              });
            }
            // function myIsNaN(value) {
            //     return typeof value === 'number' && !isNaN(value);
            // }
            this.sliceArr(this.currentRightPage, this.pageSizeRight);
            console.log(res.data.records);
            this.total = +res.data.total;
          } else {
            this.goodsList = [];
          }
        });
      }
    },
    // 所有商品
    allShop() {
      let form = this.formCopy;
      let total = this.total
      if (total >= 10000) {
        this.$message.warning("按结果选择商品不能超过10000个");
        return;
      }
      this.tableRightLoading = true;
      if (this.skuSearch) {
        getTaobaoItemListSku({
          ...form,
          current: 1,
          size: total,
          venderId: this.venderId ? this.venderId : this.$store.getters.loginUserInfo.venderId,
        }).then((res) => {
          if (res.code == 1) {
            // console.log(res.data.records);
            res.data.records.map((item) => {
              item.wareTitle = item.skuName;
            });
            this.selectAllshop(res.data.records)
          } else {
            this.allShopList = [];
          }
          this.tableRightLoading = false;
        });
      } else {
        getTaobaoItemList({
          ...form,
          page: 1,
          pageSize: total,
          current: 1,
          size: total,
          venderId: this.venderId ? this.venderId : this.$store.getters.loginUserInfo.venderId,
        }).then((res) => {
          if (res.data == null) {
            this.allShopList = [];
          }
          if (res.code == 1) {
            this.selectAllshop(res.data.records)
          } else {
            this.allShopList = [];
          }
          this.tableRightLoading = false;
        });
      }
    },
    /**
     * 更新商品
     */
    updateGoods() {
      //
      synchroJdWare().then((res) => {
        console.log(res);
        if (res.code == "1") {
          this.$message.success("正在同步店铺商品");
        } else {
          this.$message.warning(res.message);
        }
      });
      // this.$refs.inputForm.formSearch();
    },
    /**
     * 添加商品
     */
    addGoods(item) {
      console.log(item);
      if (this.xianz && this.selectedGoodsList.length >= 20) {
        this.$message.warning("选择商品不能超过20个");
        return;
      }
      if (this.limit && this.selectedGoodsList.length >= this.limit) {
        this.$message.warning(`不能超过${this.limit}个`);
        return;
      }
      if (item.isAdd) return;
      item.isAdd = true;
      if (this.skuSearch) {
        this.ids.push(item.skuId);
        
      } else {
        this.ids.push(item.wareId);
        
      }

      this.selectedGoodsList.push(item);
      this.sliceArr(this.currentRightPage, this.pageSizeRight);
      // console.log(this.ids);
      // console.log(this.selectedGoodsList);
    },
    /**
     * 全选
     */
    selectAll() {
      this.goodsList.forEach((item) => {
        if (this.xianz && this.selectedGoodsList.length >= 20) {
          this.$message.warning("选择商品不能超过20个");
          return;
        }
        if (this.limit && this.selectedGoodsList.length >= this.limit) {
          this.$message.warning(`不能超过${this.limit}个`);
          return;
        }
        if (!item.isAdd) {
          item.isAdd = true;
          this.selectedGoodsList.push(item);
          // sku维度
          if (this.skuSearch) {
            this.ids.push(item.skuId);
            
          } else {
            this.ids.push(item.wareId);
           
          }
        }
      });

      this.sliceArr(this.currentRightPage, this.pageSizeRight);
    },
    // 按结果全选
    selectAllshop(list) {
      // this.selectedGoodsList = [];
      if (list.length >= 10000) {
        this.$message.warning("按结果选择商品不能超过10000个");
        return;
      }
      this.goodsList.forEach((val) => {
        val.isAdd = true;
      });
      this.selectedGoodsList = [];
      this.ids = [];
      if(this.xianz && this.limit>0 && list.length > this.limit) {
        this.$message.warning("按结果选择商品不能超过" + this.limit + "个");
        list = list.slice(0, this.limit);
      }

      list.forEach((item) => {
        this.selectedGoodsList.push(item);
        // sku维度
        if (this.skuSearch) {
          this.ids.push(item.skuId);
        } else {
          this.ids.push(item.wareId);
        }
      });

      this.sliceArr(this.currentRightPage, this.pageSizeRight);
    },
    /**
     * 左边商品盒子分页事件
     */
    handleLeftSizeChange(val) {
      this.pageSizeLeft = val;
      this.currentLeftPage = 1;
      // this.$refs.inputForm.formSearch();
      this.searchForm();
    },
    handleLeftCurrentChange(val) {
      this.currentLeftPage = val;
      // this.$refs.inputForm.formSearch();
      this.searchForm();
    },
    /**
     * 删除商品
     */
    clearGoods(item, index) {
      // console.log(item.wareId);
      if (this.skuSearch) {
        this.goodsList.forEach((i) => {
          if (i.skuId == item.skuId) {
            i.isAdd = false;
          }
        });
        
      } else {
        this.goodsList.forEach((i) => {
          if (i.wareId == item.wareId) {
            i.isAdd = false;
          }
        });
        
      }
      if (this.moduleType) {
        if (this.skuSearch) {
          this.ids.splice(
            this.ids.findIndex((i) => i === item.skuId),
            1
          );
        } else {
          this.ids.splice(
            this.ids.findIndex((i) => i === item.wareId),
            1
          );
        }
      }
      if (this.skuSearch) {
        this.selectedGoodsList.forEach((e, i) => {
          if (e.skuId === item.skuId) {
            this.selectedGoodsList.splice(i, 1);
          }
        });
      } else {
        this.selectedGoodsList.forEach((e) => {
          if (e.wareId === item.wareId) {
            this.selectedGoodsList.splice(i, 1);
          }
        });
      }
      // this.selectedGoodsList.splice(index, 1);
      this.sliceArr(this.currentRightPage, this.pageSizeRight);
    },
    /**
     * 清空
     */
    empty() {
      console.log(this.ids);
      // return
      if (this.skuSearch) {
        this.goodsList.forEach((item, index) => {
          if (this.ids.includes(item.skuId)) {
            item.isAdd = false;
          }
        });
      } else {
        this.goodsList.forEach((item, index) => {
          if (this.ids.includes(item.wareId)) {
            item.isAdd = false;
          }
        });
      }
      
      // this.selectedGoodsList.length = 0;
      console.log(this.goodsList);
      this.ids = [];
      this.selectedGoodsList = [];
      this.showSelectedGoodsList = [];
    },
    /**
     * 右边商品盒子分页事件
     */
    handleRigthSizeChange(val) {
      this.pageSizeRight = val;
      // 分页size大于右商品盒子数组长度时
      if (this.currentRightPage * this.pageSizeRight > this.selectedGoodsList.length) {
        this.sliceArr(1, this.selectedGoodsList.length);
      } else {
        this.sliceArr(1, val);
      }
    },
    // 右边商品盒子页码事件
    handleRightCurrentChange(val) {
      this.currentRightPage = val;
      this.sliceArr(val, this.pageSizeRight);
    },
    // 根据分页信息截取数组进行显示
    sliceArr(current, size) {
      this.showSelectedGoodsList = this.selectedGoodsList.slice(size * (current - 1), size * current);
      console.log(this.showSelectedGoodsList);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__wrapper{
  z-index: 4000 !important;
}
button {
  margin: 0;
  padding: 0 12px;
  height: 32px;
  line-height: 30px;
  border: none;
  outline: none;
  border-radius: 3px;
  background-color: #fff;
  text-align: center;
  cursor: pointer;
}
.headSearchForm {
  // margin-top: 20px;
}
.notData {
  text-align: center;
  color: #909399;
  margin-top: 20%;
}
.goodsContent {
  display: flex;
  align-items: center;
  // justify-content: space-between;
  .left{
    flex: 1;
    margin-right: 12px;
  }
  .left,
  .right {
    width: 500px;
    .titleBox {
      position: relative;
      width: 100%;
      height: 48px;
      line-height: 48px;
      color: #1F1F1F;
      font-size: 14px;
      background: #F8F9FA;
      border-radius: 4px 4px 0px 0px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 12px;
      .tit{
        color: #1F1F1F;
        font-size: 14px;
      }
      .all,
      .clear {
        position: absolute;
        right: 10px;
        color: #2768FF;
        cursor: pointer;
      }
      .update {
        // margin-left: -200px;
        position: absolute;
        left: 10px;
        top: 4px;
        width: 70px;
        font-size: 14px;
        height: 28px;
        color: #ffffff;
        background-color: #2768FF;
        &:hover {
          color: #fff;
          opacity: 0.9;
          background-color: #2768FF;
        }
      }
    }
    .goodsScrollBox {
      height: 334px;
      overflow: auto;
      position: relative;
      &::-webkit-scrollbar {
        width: 8px;
        height: 10px;
      }
      &::-webkit-scrollbar-track {
        background: rgba(246, 246, 246, 1);
        border-radius: 2px;
      }
      &::-webkit-scrollbar-thumb {
        background: #ddd;
        border-radius: 10px;
      }
      &::-webkit-scrollbar-thumb:hover {
        background: #ddd;
      }
      .goods {
        display: flex;
        align-items: center;
        box-sizing: border-box;
        justify-content: space-between;
        padding: 0 16px;
        height: 80px;
        border-left: 1px solid #f3f3f3;
        border-right: 1px solid #f3f3f3;
        border-bottom: 1px solid #f3f3f3;
        transition: all 0.2s;
        position: relative;
        a {
          display: flex;
          align-items: center;
          box-sizing: border-box;
          // padding: 0 16px;
          height: 80px;
          flex: 1;
        }
        .avar {
          flex-shrink: 0;
          width: 48px;
          height: 48px;
          background-color: #f9f9f9;
        }
        .desc {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          margin: 0 0 0 8px;
          .goodsName {
            color: #666666;
            font-size: 14px;
            margin: 0 0 8px 0;
            display: -webkit-box;
            word-break: break-all;
            text-overflow: ellipsis;
            overflow: hidden;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            // -webkit-line-clamp: 2;
            line-height: 15px;
            
            // display: -webkit-box;
            // -webkit-box-orient: vertica;
            // overflow: hidden;
            // text-overflow: ellipsis;
          }
          .foot {
            display: flex;
            align-items: center;
            justify-content: space-between;
            .goodsId {
              font-size: 13px;
              color: #666666;
            }
            .money {
              font-size: 13px;
              color: #333333;
              margin-right: 16px;
            }
          }
        }
        .addIcon {
          flex-shrink: 0;
          width: 20px;
          height: 20px;
          cursor: pointer;
          transition: all 0.2s;
          position: absolute;
          top: 42px;
          right: 12px;
        }
        .clearIcon {
          flex-shrink: 0;
          width: 20px;
          height: 20px;
          cursor: pointer;
        }
      }
      .isAdd {
        background-color: #f9f9f9 !important;
        .addIcon {
          opacity: 0.3;
          cursor: not-allowed;
        }
      }
      .noDataBox {
        position: absolute;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
    .pagination {
      margin-top: 20px;
      text-align: right;
    }
  }
  .left {
  }
  .right {
  }
}
.footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 20px;
  .cancel,
  .confirm {
    width: 98px;
    font-size: 14px;
    height: 32px;
  }
  .cancel {
    margin-right: 8px;
    color: #999999;
    border: 1px solid #cccccc;
    background-color: #fff;
    &:hover {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
  }
  .confirm {
    color: #ffffff;
    background-color: #fe4d45;
    &:hover {
      color: #fff;
      opacity: 0.9;
      background-color: #fe4d45;
    }
  }
}
</style>
<style lang="scss">
.el-message-box__wrapper{
  z-index: 5000 !important;
  background: #00000080;
}
// .el-select-dropdown {
//   z-index: 3334 !important;
// }
</style>
